var map = {
	"./block-inappropriate-app.svg": "0699",
	"./block-websites.svg": "5173",
	"./browser-history.svg": "6d59",
	"./capture-clipboard.svg": "5acf",
	"./capture-screenshot-01.svg": "494c",
	"./capture-screenshot-02.svg": "6301",
	"./capture-screenshot-03.svg": "cb6a",
	"./data-output.svg": "153f",
	"./date-01.svg": "4e07",
	"./delete-01.svg": "6fcf",
	"./dialOut-refuse.svg": "8bdb",
	"./dialOut.svg": "647a",
	"./documentation.svg": "90fb",
	"./download-01.svg": "b13a",
	"./edit-01.svg": "8534",
	"./empty-01.svg": "bf4b",
	"./folder-01.svg": "9545",
	"./folder-02.svg": "b586",
	"./four-squares.svg": "5fe0",
	"./geofence.svg": "471fb",
	"./go-in-01.svg": "c7cd",
	"./go-out-01.svg": "a794",
	"./home.svg": "6bbe",
	"./image-01.svg": "bde1",
	"./incomingCall.svg": "0912",
	"./keylogger.svg": "c48f",
	"./limit-pc-usage-hours.svg": "d79f",
	"./loading.svg": "d412",
	"./localization.svg": "f0d0",
	"./location-01.svg": "5313",
	"./location-image-01.svg": "ca0a",
	"./location-image-02.svg": "1b2f",
	"./location.svg": "1c50",
	"./media-files.svg": "d7b9",
	"./menu-activities.svg": "31db",
	"./menu-call-record.svg": "59bf",
	"./menu-call.svg": "146e",
	"./menu-chats.svg": "758e",
	"./menu-clipboard.svg": "ab14",
	"./menu-dashboard.svg": "a165",
	"./menu-export.svg": "c097",
	"./menu-keyboard.svg": "a204",
	"./menu-mac.svg": "6cc2",
	"./menu-photos.svg": "2edd",
	"./menu-safari.svg": "42f4",
	"./menu-screenshots.svg": "e9ed",
	"./menu-sensitive.svg": "8cd5",
	"./menu-status.svg": "c725",
	"./menu-usb.svg": "9a2b",
	"./menu-userecord.svg": "e263",
	"./menu-videos.svg": "7814",
	"./menu-voices.svg": "bb88",
	"./monitor-app-usage.svg": "4404",
	"./phone-01.svg": "390f",
	"./phone.svg": "dd82",
	"./play-01.svg": "2aa0",
	"./play-02.svg": "2b56",
	"./preview-bg.svg": "7552",
	"./record-keyboard-input.svg": "29f4",
	"./record_img.svg": "560f",
	"./record_img2.svg": "7d34",
	"./refuse.svg": "0164",
	"./remote-control.svg": "b3e0",
	"./right-arrow-01.svg": "ac0e",
	"./search-01.svg": "0a8c",
	"./sms-reader.svg": "7e0b",
	"./snapchat.svg": "d4d4",
	"./social-application.svg": "a3aa",
	"./stealth-mode.svg": "a315",
	"./take-photo-prompt-01.svg": "af46",
	"./take-photo-prompt-02.svg": "cafc",
	"./take-screenshots.svg": "562c",
	"./track-calls.svg": "cfe0",
	"./track-social-media-activity.svg": "fa26",
	"./track-vistied-websites.svg": "06cc",
	"./user-01.svg": "3948",
	"./user-02.svg": "2391",
	"./video-bg.svg": "b004",
	"./warning-01.svg": "5e18",
	"./warning-02.svg": "93bc",
	"./wifi-01.svg": "3798"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";